export const BIZ_BASE_URL = `/api/biz`;
export const NONBIZ_BASE_URL = `/api/nonbiz`;
export const URL_REDEMPTIONS = `/api/redemptions`;
export const URL_OUTLET = BIZ_BASE_URL + '/outlets';
export const CONFIGS_URL = `/api/configs`;
export const URL_VOUCHER = '/api/vouchers';
export const URL_PRIVILEGE = '/api/prv/privileges';

// Transaction
export const URL_TRANSACTION = BIZ_BASE_URL + '/transactions/pwa';
export const URL_TRANSACTION_DETAIL_BY_MASTERID = BIZ_BASE_URL + '/ma/transactions';
export const URL_TRANSACTION_REFUND_BY_MASTERID = BIZ_BASE_URL + '/transactions';

export enum API_STATUS {
	SUCCESS = 'success',
	ERROR = 'error',
}

export enum ERROR_CODE {
	KFWE0011 = 'Error: KFWE0011',
}
